export const streams = ['Arts', 'Bio', 'Maths', 'Commerce', 'Tech'];
export const districts = [
  "කොළඹ", "ගම්පහ", "කළුතර", "මාතලේ", "මහනුවර", "නුවරඑළිය", "ගාල්ල", "මාතර", "හම්බනතොට",
  "යාපනය", "කිලිනොච්චිය", "මන්නාරම්", "මුලතිව්", "වව්නියාව", "ත්‍රිකුණාමලය", "මඩකලපුව",
  "අම්පාර", "පුත්තලම", "කුරුණෑගල", "අනුරාධපුරය", "පොළොන්නරුව", "බදුල්ල", "මොණරාගල", "කෑගල්ල", "රත්නපුර"
].map(dist => ({ value: dist, label: dist }));